import apiClient from './apiClient'
import { getOrCreateDeviceId } from '../utils/deviceId'

export type LearningActivityEventType = 'CONTENT_OPEN'

/** Fire-and-forget beacon; ignore network errors. */
export function reportLearningActivity(payload: {
  eventType: LearningActivityEventType
  courseId: number
  contentId?: number | null
}): void {
  if (!payload.courseId || payload.courseId <= 0) return
  void apiClient
    .post('/student/learning-activity', {
      eventType: payload.eventType,
      courseId: payload.courseId,
      contentId: payload.contentId ?? undefined,
      deviceId: getOrCreateDeviceId(),
    })
    .catch(() => {
      /* ignore — audit must not block learning */
    })
}
